import { FC, Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Headline } from '@/components/templates/style';
import { useUserContext } from '@/contexts/user';
import { GuidePageTitles } from '@/pages/Guide/types';
import { GuidePaths } from '@/routes/Guide';

import GuideSignup from '../Signup';
import { CustomTab, Navi, SignupBox, StyledLink, TabList } from './style';

const CommonLayout: FC = () => {
  const { isGuest, isLoggedIn } = useUserContext();

  const location = useLocation();

  const currentPath = useMemo(() => {
    const match = location.pathname.match(
      `${Object.values(GuidePaths).join('|')}`,
    );
    return match === null ? GuidePaths.About : (match[0] as GuidePaths);
  }, [location.pathname]);

  const ROUTES = [
    {
      name: GuidePageTitles.About,
      path: GuidePaths.About,
    },
    {
      name: GuidePageTitles.Flow,
      path: GuidePaths.Flow,
    },
    {
      name: GuidePageTitles.Toreta,
      path: GuidePaths.Toreta,
    },
    {
      name: GuidePageTitles.Wallet,
      path: GuidePaths.Wallet,
    },
    {
      name: GuidePageTitles.Voting,
      path: GuidePaths.Voting,
    },
    {
      name: GuidePageTitles.RaceCard,
      path: GuidePaths.RaceCard,
    },
  ];

  return (
    <>
      <Headline>DMM競輪 ご利用ガイド</Headline>
      <Navi>
        <TabList>
          {ROUTES.map(({ path, name }) => (
            <li key={path}>
              <StyledLink
                to={{
                  pathname:
                    path === GuidePaths.About ? '/guide' : `/guide/${path}`,
                }}
                state={{ cancelScroll: true }}
              >
                <CustomTab active={path === currentPath}>{name}</CustomTab>
              </StyledLink>
            </li>
          ))}
        </TabList>
      </Navi>
      <Suspense fallback={<></>}>
        <Outlet />
      </Suspense>
      {(isGuest || !isLoggedIn) && (
        <SignupBox>
          <GuideSignup />
        </SignupBox>
      )}
    </>
  );
};

export default CommonLayout;
